import {
  GET_VENDOR_MEDIA_PROFILE,
  GET_VENDOR_MEDIA_PROFILE_FAIL,
  GET_VENDOR_MEDIA_PROFILE_SUCCESS,
  GET_VENDOR_MEDIA,
  GET_VENDOR_MEDIA_FAIL,
  GET_VENDOR_MEDIA_SUCCESS,
  ADD_NEW_VENDOR_MEDIA,
  ADD_VENDOR_MEDIA_SUCCESS,
  ADD_VENDOR_MEDIA_FAIL,
  UPDATE_VENDOR_MEDIA,
  UPDATE_VENDOR_MEDIA_SUCCESS,
  UPDATE_VENDOR_MEDIA_FAIL,
  DELETE_VENDOR_MEDIA,
  DELETE_VENDOR_MEDIA_SUCCESS,
  DELETE_VENDOR_MEDIA_FAIL,
} from "./actionTypes"

export const getVendor_media = ({id,offset='',page_size=''}) => ({
  type: GET_VENDOR_MEDIA,
  payload:{id,offset,page_size}
})

export const getVendor_mediaSuccess = Vendor_media => ({
  type: GET_VENDOR_MEDIA_SUCCESS,
  payload: Vendor_media,
})

export const getVendor_mediaFail = error => ({
  type: GET_VENDOR_MEDIA_FAIL,
  payload: error,
})

export const addNewVendor_media = (user,history) => ({
  type: ADD_NEW_VENDOR_MEDIA,
  payload: {user,history},
})

export const addVendor_mediaSuccess = user => ({
  type: ADD_VENDOR_MEDIA_SUCCESS,
  payload: user,
})  

export const addVendor_mediaFail = error => ({
  type: ADD_VENDOR_MEDIA_FAIL,
  payload: error,
})

export const updateVendor_media = (user, history) => ({
  type: UPDATE_VENDOR_MEDIA,
  payload: { user, history },
})

export const updateVendor_mediaSuccess = user => ({
  type: UPDATE_VENDOR_MEDIA_SUCCESS,
  payload: user,
})

export const updateVendor_mediaFail = error => ({
  type: UPDATE_VENDOR_MEDIA_FAIL,
  payload: error,
})

export const deleteVendor_media = user => ({
  type: DELETE_VENDOR_MEDIA,
  payload: user,
})

export const deleteVendor_mediaSuccess = user => ({
  type: DELETE_VENDOR_MEDIA_SUCCESS,
  payload: user,
})

export const deleteVendor_mediaFail = error => ({
  type: DELETE_VENDOR_MEDIA_FAIL,
  payload: error,
})

export const getVendor_mediaProfile = () => ({
  type: GET_VENDOR_MEDIA_PROFILE,
})

export const getVendor_mediaProfileSuccess = userProfile => ({
  type: GET_VENDOR_MEDIA_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getVendor_mediaProfileFail = error => ({
  type: GET_VENDOR_MEDIA_PROFILE_FAIL,
  payload: error,
})
